import * as toastr from "toastr";
import { FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult, CloseFormEnum, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import { Photos } from '../Photos/Photos';

import * as events from '../Bus/Bus';
import { ActivityListType, ActivityCreateModel } from '../Activity/Activity';
import { UserDefinedFields } from '../UserDefinedFields/UserDefinedFields';
import { MapLayerGroupType, MapConfigModel, INewGeometryConfig } from '../Models/MapConfigModels';
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';
import { Entity_MaintContact } from './Entity_MaintContact';
import { Entity_MaintComment } from './Entity_MaintComment';
import { Feature } from "ol";
import { ModalPrompts, PredefinedModalEnum } from "../Utility/ModalPrompts";

// LUT table 
export class IssueTypeModel { maintType: string; maintTypeGroup: string; descr: string; }

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Maint {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;
    private Entity_MaintContact = new Entity_MaintContact();
    private Entity_MaintComment = new Entity_MaintComment();
    private newMaintWizardState: { featureSelectedCAMSKey?: ICAMSKey, featureSelected?: Feature, drawFeature?: Feature };
    private issueTypeList: Array<IssueTypeModel>;
    private photos: Photos = new Photos();

    private eventNewMapGeometryCompleted;
    private MaintStatus_Resolved = 1;

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, protected mapConfigModel: MapConfigModel) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openEditPanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();

        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Maint/IssueEdit', { maintCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Create modal
            Utilities.GetModal('#maintEditModal', ModalAction.Create);

            // Create table
            ($('#maintEditContactsTable') as any).bootstrapTable();
            ($('#maintEditTasksTable') as any).bootstrapTable();

            $('#maintEditNewContactBtn').on('click', function () {
                if (originalFormData !== $('#maintEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openContact();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openContact();
                        });
                    });
                }
                else openContact();

                function openContact() {
                    Utilities.GetModal('#maintEditModal', ModalAction.Hide);
                    self.Entity_MaintContact.openMaintContactCreatePanel(data, function (id) {
                        //self.openEditPanel(data);
                        self.Entity_MaintContact.openMaintContactEditPanel(id, function () {
                            self.openEditPanel(data);
                        });
                    });
                }
            });

            $('#maintEditModal [data-parentkey]').on('click', function () {
                const data: ICAMSKey = $(this).data("parentkey");
                if (data.featureType == FeatureType.Route) {
                    events.bus.publish(events.eventOpenRouteEditPanel(data));
                } else if (data.featureType == FeatureType.Infra) {
                    events.bus.publish(events.eventOpenInfraEditPanel([data,null]));
                } else if (data.featureType == FeatureType.Land) {
                    events.bus.publish(events.eventOpenLandEditPanel(data));
                }
                Utilities.GetModal('#maintEditModal', ModalAction.Hide);
            });

            var table: any = Utilities.GetControl('#maintEditContactsTable');
            table.bootstrapTable(); 
            //$('#maintEditModal [data-contactid]').on('click', function () {
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "name") {
                    var ID: number = $element.data("contactid");
                    if (originalFormData !== $('#maintEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openContact();
                            else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                if (s == true) openContact();
                            });
                        });
                    }
                    else openContact();
                }               

                function openContact() {
                    Utilities.GetModal('#maintEditModal', ModalAction.Hide);
                    self.Entity_MaintContact.openMaintContactEditPanel(ID, function () {
                        self.openEditPanel(data);
                    });
                }
            });

            $('#maintEditNewTaskBtn').on('click', function () {
                if (originalFormData !== $('#maintEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#maintEditModal', ModalAction.Hide);
                    events.bus.publish(events.eventOpenTasksCreatePanel([[data], function (r) {
                        events.bus.publish(events.eventOpenMaintEditPanel(data)); // This re-opens the edit form which refreshes the Maint form
                        //if (r == true) {
                        //    events.bus.publish(events.eventOpenMaintEditPanel(data)); // This re-opens the edit form which refreshes the Maint form
                        //}
                        //else {
                        //    Utilities.GetModal('#maintEditModal', ModalAction.Show);
                        //}
                    }]));
                }
            });

            // ACTIVITY
            getActivities(true); // Get activities when the form first loads
            $('#maintEditModal [name="showAllActivities"]').on('change', function () {
                var checked = $(this).prop('checked');
                getActivities(!checked);
            });

            function getActivities(excludeAuditActivities: Boolean) {
                events.bus.publish(events.eventGetActivities([data, excludeAuditActivities, function (d) {
                    var table = ($('#maintEditActivityTable') as any);
                    table.bootstrapTable();
                    table.bootstrapTable('load', d);

                    // Add entity cklick events
                    //$('#maintEditModal [data-activityid]').on('click', function () {
                    table.on('click-cell.bs.table', function (e, field, value, row, $element) { 
                        if (field == "uid") {
                            var ID: number = $element.find("[data-activityid]").data("activityid");
                            if (originalFormData !== $('#maintEditForm').serialize()) {
                                Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                                    if (r == CloseFormEnum.DisregardAndProceed) openContact();
                                    else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                        if (s == true) openContact();
                                    });
                                });
                            }
                            else openContact();
                        }                       

                        function openContact() {
                            Utilities.GetModal('#maintEditModal', ModalAction.Hide);
                            events.bus.publish(events.eventOpenActivityDetailsPanel([ID, function (r) {
                                if (r == true) {
                                    events.bus.publish(events.eventOpenMaintEditPanel(data)); // This re-opens the edit form which refreshes the Maint form
                                }
                                else {
                                    Utilities.GetModal('#maintEditModal', ModalAction.Show);
                                }
                            }]));
                        }
                    });
                }]));
            }

            $('#maintEditNewActivityBtn').on('click', function () {
                if (originalFormData !== $('#maintEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#maintEditModal', ModalAction.Hide);
                    var activityData: ActivityCreateModel = { ID: data.code, activityListType: ActivityListType.MaintActivity };
                    events.bus.publish(events.eventOpenActivityCreatePanel([activityData, function (r) {
                        if (r == true) {
                            events.bus.publish(events.eventOpenMaintEditPanel(data)); // This re-opens the edit form which refreshes the Maint form
                        }
                        else {
                            Utilities.GetModal('#maintEditModal', ModalAction.Show);
                        }
                    }]));
                }
            });

            // DONE DATE CHANGE
            $('#maintEditModal [name="DoneDate"]').on('change', function () {
                if ($('#maintEditModal [name="Status"]').val() != self.MaintStatus_Resolved) {
                    toastr.info("Setting status to 'Resolved'.");
                    $('#maintEditModal [name="Status"]').val(self.MaintStatus_Resolved);
                }
            });

            $('#IssueGroupType').on('change', function () {
                self.issueTypeChanged();
                UserDefinedFields.ShowHideUDFs(<string>$('#IssueType').children("option:selected").val(), $("#maintEditForm"));
            });

            var table: any = Utilities.GetControl('#maintEditTasksTable');
            table.bootstrapTable(); 
            //$('#maintEditModal [data-taskid]').on('click', function () {
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "taskType") {
                    Utilities.GetModal('#maintEditModal', ModalAction.Hide);
                    var taskID = $element.data('taskid');
                    var camsKey: ICAMSKey = { code: taskID, featureType: FeatureType.Task };
                    events.bus.publish(events.eventOpenTasksEditPanel([camsKey, function (r) {
                        events.bus.publish(events.eventOpenMaintEditPanel(data));
                        //if (r == true) {
                        //    events.bus.publish(events.eventOpenMaintEditPanel(data)); // This re-opens the edit form which refreshes the Maint form
                        //}
                        //else {
                        //    Utilities.GetModal('#maintEditModal', ModalAction.Show);
                        //}
                    }]));
                }
                
            });

            // Get UDF's and conditional fields
            $('#IssueType').on('change', function () {
                UserDefinedFields.ShowHideUDFs(<string>$('#IssueType').children("option:selected").val(), $("#maintEditForm"));
            });
            UserDefinedFields.ShowHideUDFs(<string>$('#IssueType').children("option:selected").val(), $("#maintEditForm"));

            //initialise photo uploader
            self.photos.setupUploader('#maintEditModal');

            // Get form validation
            Utilities.InitFormValidation($("#maintEditModal"));

            $('#maintEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                doSubmit().then(s => { if (s == true) Utilities.GetModal('#maintEditModal', ModalAction.Hide); });
            });

            function doSubmit() {
                return new Promise<boolean>(function (resolve, reject) {
                    // Validate
                    let form: any = $('#maintEditForm');
                    if (Utilities.CheckFormValidation(form)==false) return;

                    Utilities.BlockUI($("#maintEditModal .modal-content"));
                    let formData = new FormData(<any>$('#maintEditForm')[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: window.G_SITEFOLDERNAME + '/Maint/UpdateIssue',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                    UserDefinedFields.SaveUDFFieldsAtServer($('#maintEditForm'), '/Maint/UpdateMaintUserFields');
                                    events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));
                                    events.bus.publish(events.eventEntityUpdated(data));
                                    resolve(true);
                                }
                                else {
                                    if (result.message != null) toastr.error(result.message);
                                    else Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                                    resolve(false);
                                }
                            }
                            catch (err) {
                                console.log(err);
                                resolve(false);
                            }
                            finally {
                                Utilities.UnBlockUI($("#maintEditModal .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                        resolve(false);
                    });
                });
            }

            $('#maintEditCancelBtn').on('click', function (evt) {
                if (originalFormData !== $('#maintEditForm').serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) Utilities.GetModal('#maintEditModal', ModalAction.Hide);
                    });
                }
                else Utilities.GetModal('#maintEditModal', ModalAction.Hide);
            });

            $('#maintEditCloseBtn').on('click', function (evt) {
                if (originalFormData !== $('#maintEditForm').serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) Utilities.GetModal('#maintEditModal', ModalAction.Hide);
                    });
                }
                else Utilities.GetModal('#maintEditModal', ModalAction.Hide);
            });

            $('#maintEditDeleteBtn').on('click', function (evt) {
                self.deleteEntity(data);
            });

            // Load the infra types if required
            if (self.issueTypeList == null) self.loadIssueLUTs();

            // Save the original state of the edit form
            var originalFormData = $('#maintEditForm').serialize();
        });
    }
    
    public openCreatePanel = (data: ICAMSKey, callback: Function = null): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Maint/IssueCreate', data, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            else if (xhr.status === 500) {
                toastr.error('Failed to create feature geometry (Invalid feature)');
            }

            Utilities.UnBlockUI();
            Utilities.GetModal('#maintCreateModal', ModalAction.Create);
            $('#IssueGroupType').on('change', function () { self.issueTypeChanged(); });

            //initialise photo uploader
            self.photos.setupUploader('#maintCreateModal');

            // Get form validation
            Utilities.InitFormValidation($("#maintCreateModal"));

            $('#maintCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                submit(false);
            });

            $('#maintCreateSubmitAndEditBtn').on('click', function (evt) {
                evt.preventDefault();
                submit(true);
            });

            function submit(showEditForm: Boolean) {
                
                // Validate
                let form: any = $('#maintCreateForm');
                if (Utilities.CheckFormValidation(form) == false) return;
                debugger;
    
                Utilities.BlockUI($("#maintCreateModal .modal-content"));
                let formData = new FormData(<any>$('#maintCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: window.G_SITEFOLDERNAME + '/Maint/CreateIssue',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetModal('#maintCreateModal', ModalAction.Hide);
                                events.bus.publish(events.eventClearEditLayer());
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));
                                events.bus.publish(events.eventEntityUpdated(data));

                                if (callback != null) {
                                    callback(result.data.maintCode);
                                    self.openEditPanel({ code: result.data.maintCode, featureType: FeatureType.Maint });
                                }
                                else {
                                    self.newMaintWizard_Start(data, self.newMaintWizardState?.featureSelected, callback);
                                    if (showEditForm == true) {
                                        self.openEditPanel({ code: result.data.maintCode, featureType: FeatureType.Maint })
                                    }
                                }

                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                                
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#maintCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            }

            $('#maintCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#maintCreateModal', ModalAction.Hide);
                if (callback != null) callback(null);
                else events.bus.publish(events.eventNewMapGeometryRestart(null));
            });

            $('#maintCreateCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#maintCreateModal', ModalAction.Hide);
                if (callback != null) callback(null);
                else events.bus.publish(events.eventNewMapGeometryRestart(null));
            });

            // Load the infra types if required
            if (self.issueTypeList == null) self.loadIssueLUTs();
        });
    }

    public openRejectPanel = (camsKey: ICAMSKey, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Maint/IssueRejectView', { maintCode: camsKey.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#maintRejectModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#maintRejectForm"));

            $('#maintRejectSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#maintRejectForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.MaintRejectIssue }).then(r => {
                    if (r.yes == true) {
                        doReject();
                    }
                    else {
                        Utilities.UnBlockUI($('#submissionListEditContainer'));
                    }
                }).catch(e => { });

                function doReject() {
                    Utilities.BlockUI($("#maintRejectModal .modal-content"));
                    let formData = new FormData(<any>$('#maintRejectForm')[0]);

                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: window.G_SITEFOLDERNAME + '/Maint/RejectIssue',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    toastr.info('Rejected issue!');
                                }
                                else {
                                    toastr.error('Failed to reject task!');
                                }

                                if (callback != null) callback(result);
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.GetModal('#maintRejectModal', ModalAction.Hide);
                                Utilities.UnBlockUI($("#maintRejectModal .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }
            });

            $('#maintRejectCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#maintRejectModal', ModalAction.Hide);
            });
        });
  
    }

    public openCommentCreatePanel = (camsKey: ICAMSKey): void => {
        const self = this;
        self.Entity_MaintComment.openCommentCreatePanel(camsKey);
    }

    // ----------------------------------------------------------- //
    // New Maint WIZARD
    public newMaintWizard_Start = (data: ICAMSKey, featureSelected: Feature = null, callback: Function): void => {
        const self = this;

        // Make sure the various layers are turned on
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.MyMaint, true]));
        events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Maint, true]));

        // Capture the end process
        self.eventNewMapGeometryCompleted = events.bus.subscribe(events.eventNewMapGeometryCompleted, e => {
            self.eventNewMapGeometryCompleted();
            if (e.payload[0] == true) {
                self.openCreatePanel(e.payload[1], callback);
            }
        });

        // Start the process
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false, selectableLayers: [FeatureType.Route, FeatureType.Infra, FeatureType.Land] };
        let config: INewGeometryConfig = { data: data, featureType: FeatureType.Maint, featureSelected: featureSelected, interactionData: interactionData, createEntityMaxDistanceAway: self.mapConfigModel.createEntityMaxDistanceAway};
        events.bus.publish(events.eventNewMapGeometryStart([config, callback]));
    }

    // ----------------------------------------------------------- //
    // GET FEATURE
    public getFeatureAndZoomToLocation = (data: ICAMSKey): void => {
        $.post('/Maint/GetIssue', { code: data.code },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        if (result.data.WKT != null) {
                            events.bus.publish(events.eventZoomToWKTandHighlight([[result.data.WKT], true, true, FeatureType.Maint]));
                        }
                        else {
                            toastr.error('Failed to get issue geometry!');
                        }
                    }
                    else {
                        toastr.error('Failed to get issue!');
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (data: ICAMSKey): void => {
        const self = this;

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post(window.G_SITEFOLDERNAME + '/Maint/DeleteIssue', data,
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.Maint));
                            events.bus.publish(events.eventClearAllHighlights());
                            events.bus.publish(events.eventResetAllPanels());
                            events.bus.publish(events.eventRemoveAllMapInteractions());
                            events.bus.publish(events.eventResetAllButtons(true));
                            Utilities.GetModal('#maintEditModal', ModalAction.Hide);
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    private issueTypeChanged = (): void => {
        // Remove all options
        $('#IssueType').find('option').remove().end();

        // Populate the list based on the selected group name
        let issueGroupTypeStr = $('#IssueGroupType').children("option:selected").val(); // Get the selected option
        this.issueTypeList.forEach(i => {
            if (i.maintTypeGroup == issueGroupTypeStr) {
                $('#IssueType').append($("<option></option>").attr("value", i.maintType).text(i.descr));
            }
        });
    }

    private loadIssueLUTs = (): void => {
        const self = this;
        $.ajax({
            url: window.G_SITEFOLDERNAME + '/LUT/GetMaintTypeLUT',
            success: function (data) {
                self.issueTypeList = data;
            },
            error: function (e) {
                console.log("Error getting GetMaintTypeLUT", e);
            }
        });
    }

}




